import {
  DriverMixerAdjustmentsDetail,
  DriverMixerAdjustmentsDetailRequest,
  DriverMixerAdjustmentsInfoItem,
  DriverMixerAdjustmentsItem,
} from 'bus/driverMixerAdjustments/types';

import { PayloadRequest } from 'types/requestTypes';

import $axios from '../utils/axios-instance';

export default class DriverMixerAdjustmentsApi {
  async getDriverMixerAdjustments(data: PayloadRequest) {
    return await $axios
      .get<DriverMixerAdjustmentsItem>(`/v1/driverMixerAdjustments/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async createDriverMixerAdjustments(data: DriverMixerAdjustmentsItem) {
    return await $axios
      .post('/v1/driverMixerAdjustments/', data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async editDriverMixerAdjustments(data: DriverMixerAdjustmentsItem) {
    return await $axios
      .put(`/v1/driverMixerAdjustments/${data.id}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async deleteDriverMixerAdjustments(data: PayloadRequest) {
    return await $axios
      .delete(`/v1/driverMixerAdjustments/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getDriverMixerAdjustmentsInfo(data: PayloadRequest) {
    return await $axios
      .get<DriverMixerAdjustmentsInfoItem>(`/v1/driverMixerAdjustments/${data.id}/info`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  //detail
  async getDriverMixerAdjustmentsDetailList(data: PayloadRequest) {
    return await $axios
      .get<DriverMixerAdjustmentsDetail[]>(`/v1/driverMixerAdjustments/${data.id}/details`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getDriverMixerAdjustmentsDetailOne(data: PayloadRequest) {
    return await $axios
      .get<DriverMixerAdjustmentsDetail>(`/v1/driverMixerAdjustments/details/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async createDriverMixerAdjustmentsDetail(data: DriverMixerAdjustmentsDetailRequest) {
    return await $axios
      .post(`/v1/driverMixerAdjustments/${data.adjustmentId}/details`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async editDriverMixerAdjustmentsDetail(data: DriverMixerAdjustmentsDetailRequest) {
    return await $axios
      .put(`/v1/driverMixerAdjustments/details/${data.id}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async deleteDriverMixerAdjustmentsDetail(data: PayloadRequest) {
    return await $axios
      .delete(`/v1/driverMixerAdjustments/details/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
